import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';
import { funnelInputCharsetProperty } from './funnel-input-charset';

export const CARTFUNNELTEXTITEMBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "placeholder",
  "input_charset",
  "required",
  "display_custom_title_in_comment",
  "custom_title"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartFunnelTextItemBlockDescriptor: _generatedCartFunnelTextItemBlockDescriptor,
  cartFunnelTextItemBlockBlocDefinition,
  cartFunnelTextItemBlockDashboardLayout,
  cartFunnelTextItemBlockConfig,
  cartFunnelTextItemBlockResolveConfig,
  cartFunnelTextItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart funnel / Text input",
    componentType: 'CartFunnelTextItemBlockComponent',
    category: 'cart',
    description: "Cart funnel / Text input.",
    keywords: [],
    allowedIn: [
      { bloc: "CartFunnelFormBlockComponent", slot: "items" },
    ],
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-text-item.title.label",
        help: "pages.blocks.cart-funnel-text-item.title.help",
      }
    }),
    placeholder: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-text-item.placeholder.label",
      }
    }),
    input_charset: funnelInputCharsetProperty("cart-funnel-text-item"),
    required: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.cart-funnel-text-item.required.label",
      }
    }),
    display_custom_title_in_comment: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.cart-funnel-text-item.display-custom-title-in-comment.label",
      }
    }),
    custom_title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-text-item.custom-title.label",
        help: "pages.blocks.cart-funnel-text-item.custom-title.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-funnel-text-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-funnel-text-item.fieldset.field.label",
            fields: ["title", "placeholder", "input_charset", "required"],
          },
          {
            legend: "pages.blocks.cart-funnel-text-item.fieldset.order-comment.label",
            fields: [
              "display_custom_title_in_comment",
              {
                prop: "custom_title",
                visibleWhen: { display_custom_title_in_comment: true },
              },
            ],
          },
        ],
      },
    ],
  })
);

export function cartFunnelTextItemBlockDescriptor(): IBlockDescriptor;
export function cartFunnelTextItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartFunnelTextItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartFunnelTextItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartFunnelTextItemBlockDescriptor, cartFunnelTextItemBlockProperties, fieldOrder);
}

export {
  cartFunnelTextItemBlockBlocDefinition,
  cartFunnelTextItemBlockDashboardLayout,
  cartFunnelTextItemBlockProperties,
  cartFunnelTextItemBlockConfig,
  cartFunnelTextItemBlockResolveConfig,
};

export type CartFunnelTextItemBlockConfig = typeof cartFunnelTextItemBlockConfig;
